<template>
  <div
    :id="`id_${id}`"
    :style="[indent]"
  >
    <v-toolbar
      v-show="parentNode.nodeType!=='Site'"
      dense
      class="tree-toolbar mb-1"
      :class="bgColor"
      :elevation="3"
    >
      <v-btn
        icon
      >
        <v-icon
          large
          class="hidden-md-and-down"
          color="primary"
        >
          mdi-drag-vertical
        </v-icon>
        <v-icon
          v-if="hasChildren"
          large
          color="primary"
          @click="toggleChildren(null)"
        >
          {{ iconArrow }}
        </v-icon>
      </v-btn>
      <span class="siteTree-title">
        {{ nodeTitle }}
      </span>
      <v-spacer />
    </v-toolbar>
    <div v-if="showChildrenStats">
      <draggable
        :list="nodes"
        :group="{ name: 'g1' }"
        :move="checkMove"
        @end="onEnd"
      >
        <div
          v-for="node in nodes"
          :key="node.ref"
        >
          <Drag
            :id="node.ref"
            :name="node.name"
            :nodeType="node.nodeType"
            :nodeTypeId="node.type.id"
            :nodeItem="node"
            :nodes="node.children"
            :parentNode="{
              id,
              name,
              nodeType,
              nodeTypeId
            }"
            :site="site"
            :depth="depth + 1"
            :path="pathName"
            :showAll="showAll"
            @nodeItemChanged="$emit('nodeItemChanged', $event)"
            @dragAndDropEnded="onDrapAndDropEnded"
          />
        </div>
      </draggable>
    </div>
  </div>
</template>
<script>
import EventBus from '@/utilities/event-bus';
import treeMixin from '@/mixins/TreeMixin';
import draggable from 'vuedraggable';

export default {
    name: 'Drag',
    components: {
        draggable,
    },
    mixins: [
        treeMixin,
    ],
    props: {
        nodes: {
            type: null,
            default: () => [],
        },
        isEditable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            status: false,
            payload: {},
            currentStatus: false,
        };
    },
    computed: {
        showChildrenStats() {
            return this.depth === 1 ? true : this.mutableNodeItem?.showChildren;
        },
        hasChildren() {
            return this.nodes.length > 0;
        },
    },
    methods: {
        checkMove(evt) {
            let targetNode = {};
            if (evt.relatedContext.component.$parent.parentNode.nodeType === 'Site') {
                targetNode = {
                    isRoot: true,
                };
            } else {
                targetNode = {
                    id: evt.relatedContext.component.$parent.id,
                    nodeType: evt.relatedContext.component.$parent.nodeType,
                };
            }
            this.payload = {
                currentNode: {
                    id: evt.draggedContext.element.ref,
                    nodeType: evt.draggedContext.element.nodeType,
                    newIndex: evt.draggedContext.futureIndex,
                },
                targetNode,
            };
            return true;
        },
        async onEnd() {
            try {
                const parentNodeType = this.payload.targetNode.nodeType || this.payload.targetNode.isRoot;
                const currentNodeType = this.payload.currentNode.nodeType;

                if ((parentNodeType === 'Container' && currentNodeType === 'Component')
                || (parentNodeType === 'Network' && currentNodeType === 'Container')
                || (parentNodeType === true && currentNodeType === 'Component')) {
                    this.$toasted.global.toast_error({
                        message: this.$t('msg.nodeMoved'),
                    });
                    EventBus.$emit('toggle-action');
                    return false;
                }
                const { data } = await this.$rq.reorderSiteTree(this.siteId, this.payload);
                this.$emit('dragAndDropEnded', data);
                return data;
            } catch (err) {
                EventBus.$emit('toggle-action');
                return err;
            }
        },
        onDrapAndDropEnded(data) {
            this.$emit('dragAndDropEnded', data);
        },
    },
};
</script>

<style lang="scss" scoped>
  .tree-toolbar {
    &.theme--light {
      .v-toolbar__content {
        .v-toolbar__items {
          .v-icon {
            color: #fff;
          }
        }
      }
    }
  }
  .v-list-item::v-deep {
    .v-icon {
      margin-right: 8px;
    }
  }
</style>
